module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Bold-aa521effcaf78afa30b05063b7aea22e.svg";